import { render, staticRenderFns } from "./InternalInformationList.vue?vue&type=template&id=2432604b&scoped=true&"
import script from "./InternalInformationList.vue?vue&type=script&lang=ts&"
export * from "./InternalInformationList.vue?vue&type=script&lang=ts&"
import style0 from "./InternalInformationList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InternalInformationList.vue?vue&type=style&index=1&id=2432604b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2432604b",
  null
  
)

component.options.__file = "InternalInformationList.vue"
export default component.exports